import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);
export default {
    data() {
        return{
            no: null,
            name: '',
            price: '',
            priceOrg: '',
            country: 1,
            cycleDay: '',
        }
    },
    validators: {
        no: function (value) {
            return Validator.value(value)
        },
        country: function (value) {
            return Validator.value(value)
        },
        name: function (value) {
            return Validator.value(value)
                .required('상품이름을 입력해주세요.')
        },
        cycleDay: function (value) {
            return Validator.value(value)
                .required('구독기간을 입력해주세요.')
                .integer('구독기간은 숫자만 입력가능합니다.')
        },
        priceOrg: function (value) {
            return Validator.value(value)
                .required('상품원가를 입력해주세요.')
                .integer('상품원가는 숫자만 입력가능합니다.')
        },
        price: function (value) {
            return Validator.value(value)
                .required('상품 판매가를 입력해주세요.')
                .integer('상품 판매가는 숫자만 입력가능합니다.')
                // .lessThanOrEqualTo(this.priceOrg, '상품 판매가는 상품원가보다 작거나 같아야합니다.')
        },
    },
    methods:{
    }
}
